import SectionTitle from "../../../components/section-title";

const DirectorContainer = () => {
    return (
        <section className="director-section bg-white" style={{ padding: "80px 0" }}>
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-6 mb-4 mb-lg-0" data-aos="fade-right" data-aos-duration="1200">
                        <div className="director-thumb text-center">
                            <img
                                src={process.env.PUBLIC_URL + "/img/photos/main_2man.png"}
                                alt="정환교 원장 · 정의성 원장"
                                width="1448"
                                height="1086"
                                style={{ width: "100%", height: "auto", maxWidth: "520px", borderRadius: "12px" }}
                            />
                        </div>
                    </div>
                    <div className="col-lg-6" data-aos="fade-left" data-aos-duration="1200">
                        <SectionTitle
                            classOption="text-start"
                            subTitle="GREETINGS"
                            title="<span>40년의 신뢰,</span> 두 원장이 함께합니다"
                        />
                        <p style={{ lineHeight: 1.9 }}>
                            아버지와 아들, 두 원장이 한 자리에서 진료를 이어갑니다.
                            세대를 넘어 변하지 않은 정직한 진료로, 늘 곁에 있는 피부과가 되겠습니다.
                        </p>

                        <div className="director-credentials mt-4">
                            <h6 className="director-credentials__heading">경력</h6>
                            <ul className="director-credentials__list">
                                <li>(현) 정환교피부과의원 원장</li>
                                <li>(현) 전북대학교 의과대학 외래교수</li>
                            </ul>

                            <h6 className="director-credentials__heading mt-3">학회 활동</h6>
                            <ul className="director-credentials__societies">
                                <li>대한피부과의사회 정회원</li>
                                <li>대한피부항노화학회 정회원</li>
                                <li>대한피부임상치료연구회 정회원</li>
                                <li>대한피부레이저학회 정회원</li>
                                <li>대한모발학회 정회원</li>
                                <li>대한아토피피부염학회 정회원</li>
                                <li>대한접촉피부염알레르기학회 정회원</li>
                                <li>대한의진균학회 정회원</li>
                                <li>대한피부암학회 정회원</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default DirectorContainer;
